import api from 'api';

const qs = require('qs');

const PATH = '/RelatorioGrafico';

const GET_RELATORIO_GRAFICO = async (filtros) => {
  const { data } = await api.get(`${PATH}/get-relatorio-grafico`, {
    params: filtros,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  });
  return data;
};

export default GET_RELATORIO_GRAFICO;
